<template>
  <div v-if="data">
    <!-- <template v-for="item in data.gtArray"> -->
    <!--  预留的单击事件  -->
    <!-- 文字悬浮 -->
    <el-tooltip class="item"
                effect="dark"
                :content="item.taskName"
                placement="top-start"
                :open-delay="500"
                v-for="(item,index) in data.gtArray"
                :key='index'>
      <div @click="showTaskDetail(item)"
           :key="item.id"
           class="gantt-block-item plan"
           :style="{
               left:getPositonOffset(item.start)+'px',
               width:getWidthAbout2Times(item.start,item.end)+'px',
               top: gtCurrentHeight(data.totalRow, item.rowNum).top + 'px',
               height: gtCurrentHeight(data.totalRow, item.rowNum).cellItemH + '%',
               'background-color': statusColor(item)}">
        <!--   渲染任务名称   -->
        <span>{{item.taskName}}</span>
      </div>
    </el-tooltip>
    <!-- </template> -->
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: "TableContent",
  props: {
    data: Object,
    getPositonOffset: Function,
    getWidthAbout2Times: Function,
    cellHeight: Number
  },
  data () {
    return {

    }
  },
  methods: {
    myDayjs (date) {
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    },
    /**
     * 根据不同区域显示不同得色块
     *  注意 后端的area字段对应的值必须与这里定义的一样
     * @param item
     * @returns {*|string}
     */
    statusColor (item) {
      let areaColor = {
        'TAOnly': 'rgb(170,163,142)',
        'Internal': 'rgb(254,203,0)',
        'Dealer': 'rgb(173,185,206)',
        'Partner': 'rgb(176,176,64)',
        'BEST': 'rgb(255,144,0)'
      };
      // // eslint-disable-next-line
      // // console.log('statusColor===>', item, areaColor[item['area']]);
      // // 如果存在给它赋对应的颜色，否则给默认颜色值
      // return areaColor[item['area']] || 'rgb(191, 242, 254)';
      if (item['colorR'] === null || item['colorG'] === null || item['colorB'] === null) {
        return areaColor[item['area']] || 'rgb(102,112,132)';
      } else {
        return 'rgb(' + item['colorR'] + ',' + item['colorG'] + ',' + item['colorB'] + ')';
      }

    },
    /**
     *  获取当前任务块的高度和离顶部的距离
     * @param totalRow
     * @param rowNum
     * @returns {{top: number, cellItemH: number}}
     */
    gtCurrentHeight (totalRow, rowNum) {
      if (totalRow === 1) {
        return {
          // top: (this.cellHeight / totalRow) * (rowNum - 1),
          top: 3,
          cellItemH: 80 / totalRow
        }
      } else {
        return {
          // top: (this.cellHeight / totalRow) * (rowNum - 1),
          top: 30 * (rowNum - 1),
          cellItemH: 80 / totalRow
        }
      }
    },
    /**
     * 单击任务块触发
     * @param data
     */
    showTaskDetail (data) {
      // eslint-disable-next-line
      console.info('预留的单击事件==>', data)
      // eslint-disable-next-line
      // alert('预留的单击事件!')
      // 延迟加载
      this.$nextTick(() => {
        this.$router.push({
          name: 'learning-offering-offeringShow',
          query: { offeringId: data.id, isShowEdit : this.checkEditRole(data) }
        })
        this.$eventHub.$emit('showViewOffering', this.checkEditRole(data))
      })
    },
    // 校验排期查看按钮权限
    checkEditRole (row) {
      let userId = JSON.parse(sessionStorage.getItem('v1user_data')).userId
      if (row.offeringStatus === '30' || row.offeringStatus === '40') {
        return false
      }

      if(this.$hasPermission('learning:offering:editselfcreated')){
        if (row.createUser === userId ){
          return true
        }
      }else {
        if (this.$hasPermission('learning:offering:editselfcreated')) {
          return true
        }
        if (this.$hasPermission('learning:offering:offeringEdit')) {
          return true
        }
        if (this.$hasPermission('TEAM:' + row.courseTeamCatalogSecond)) {
          return true
        }
      }

      return false
    }
  }
}
</script>


<style scoped>
.plan {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  /*height: 40%;*/
  border: 1px solid #f0f0f0;
  background-color: rgb(191, 242, 254);
  border-radius: 5px;
  /*color: #333333;*/
  color: black;
  padding-left: 5px;
  font-size: 0.8rem;
  /*opacity: 0.8;*/
  white-space: nowrap; /*内容超宽后禁止换行显示*/
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /*文字超出部分以省略号显示*/
}
</style>
